import { PropsWithChildren } from "react";
import { ExpandButton } from "./ExpandButton";

interface CollapseButtonProps {
    className?: string;
    /**
     * Whether the icon is currently "expanded" or "collapsed".
     */
    collapsed: boolean;
    /**
     * Callback when the button is clicked.
     * @param collapsed
     */
    onToggle(collapsed: boolean): void;
    /**
     * Whether the button is disabled.
     */
    disabled?: boolean;
}

export function CollapseButton({ collapsed, onToggle, ...props }: PropsWithChildren<CollapseButtonProps>) {
    return <ExpandButton expanded={!collapsed} onToggle={(expanded) => onToggle(!expanded)} {...props} />;
}
